import { relatorios } from '../utils/constants'

export default [
  {
    icon: 'mdi-monitor-dashboard',
    title: 'Início',
    to: '/admin/dashboard',
    group: '',
  },
  {
    icon: 'mdi-cart-outline',
    title: 'Lançamentos',
    group: '/admin/cdv',
    children: [
      {
        icon: 'mdi-file-document-outline',
        title: 'Movimento de Atendimento',
        to: 'atendimento',
      },
    ],
  },
  {
    icon: 'mdi-bullhorn-outline',
    title: 'Comunicações',
    group: '/admin/ccc',
    children: [
      {
        icon: 'mdi-card-account-mail-outline',
        title: 'Mensagens Produtor',
        to: 'notificacoesProdutor/?tipo=P',
      },
      {
        icon: 'mdi-card-account-details-star-outline',
        title: 'Mensagens Técnico',
        to: 'notificacoesTecnico/?tipo=T',
      },
    ],
  },
  {
    icon: 'mdi-package-variant-closed',
    title: 'Produtos/Serviços',
    group: '/admin/cdc',
    children: [
      {
        icon: 'mdi-book-open-page-variant-outline',
        title: 'Catálogos',
        to: 'catalogos',
      },
      {
        icon: 'mdi-package-variant-closed',
        title: 'Produtos',
        to: 'produtos',
      },
      {
        icon: 'mdi-toolbox',
        title: 'Serviços',
        to: 'servicos',
      },
      {
        icon: 'mdi-scale-balance',
        title: 'Unidades de medida',
        to: 'unidadesmedida',
      },
      {
        icon: 'mdi-shape-outline',
        title: 'Categorias',
        to: 'categorias',
      },
      {
        icon: 'mdi-cash-multiple',
        title: 'Planos de Pagamento',
        to: 'plano-pagamento',
      },
    ],
  },
  {
    icon: 'mdi-account-details',
    title: 'Pessoas',
    group: '/admin',
    children: [
      {
        icon: 'mdi-account-cowboy-hat',
        title: 'Produtores',
        to: 'produtores',
      },
      {
        icon: 'mdi-barn',
        title: 'Fazendas',
        to: 'fazendas',
      },
      {
        icon: 'mdi-account-supervisor',
        title: 'Empresas conveniadas',
        to: 'fornecedores',
      },
      {
        icon: 'mdi-account-hard-hat',
        title: 'Técnicos',
        to: 'tecnicos',
      },
      {
        icon: 'mdi-account-child-outline',
        title: 'Supervisores',
        to: 'supervisores',
      },
      {
        icon: 'mdi-account-tie',
        title: 'Gestores',
        to: 'gestores',
      },
      {
        icon: 'mdi-account-star',
        title: 'Administradores',
        to: 'administradores',
      },
    ],
  },
  {
    icon: 'mdi-factory',
    title: 'Unidades de Negócio',
    group: '/admin',
    children: [
      {
        icon: 'mdi-city-variant-outline',
        title: 'Unidades de Negócio',
        to: 'unidadesnegocio',
      },
      {
        icon: 'mdi-sitemap',
        title: 'Setor',
        to: 'setores',
      },
      {
        icon: 'mdi-map-marker-path',
        title: 'Regionais',
        to: 'regionais',
      },
    ],
  },
  {
    icon: 'mdi-note-text',
    title: 'Relatórios',
    group: '/admin/relatorio',
    children: [
      {
        icon: 'mdi-circle-medium',
        title: 'Serviços efetuados por produtor',
        subtitle: 'Produtor',
        to: relatorios.servicosProdutor,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Serviços por Técnico',
        subtitle: 'Resumo',
        to: relatorios.servicoTecnicos,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Atendimentos por Empresa',
        subtitle: 'Empresa',
        to: relatorios.atendimentoEmpresa,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Resumo dos Serviços',
        subtitle: 'Resumo',
        to: relatorios.resumoServicos,
      },
    ],
  },
  {
    icon: 'mdi-application-cog',
    title: 'Configurações',
    group: '/admin/conf',
    children: [
      {
        icon: 'mdi-cloud-upload-outline',
        title: 'Integrações',
        subtitle: 'Importação de dados',
        to: 'integracoes',
      },
      {
        icon: 'mdi-account-lock',
        title: 'Controle de Acesso',
        subtitle: 'Permissões seletivas',
        to: 'acessos',
      },
      {
        icon: 'mdi-text-box-search-outline',
        title: 'Logs de acesso',
        subtitle: 'Registro de atividades',
        to: 'logs',
      },
    ],
  },
]
